import { defineStore } from "pinia";
import { ref } from "vue";
import { Organisation, Form } from "@/helpers/interfaces/organisations";

/**
 * Organisation store to manage organisation-related data such as shortcode,
 * form name, organisation details, and form structure.
 * The store persists data in sessionStorage to maintain state across page
 * reloads within the same session.
 */
export const useOrganisationStore = defineStore(
    "organisation",
    () => {
        // ── State ──────────────────────────────────────────────────────────────
        const shortcode = ref<string | null>(null);
        const formName = ref<string | null>(null);
        const organisation = ref<Organisation | null>(null);
        const formStructure = ref<Form | null>(null);

        // ── Actions ────────────────────────────────────────────────────────────
        function setShortcode(orgShortcode: string | null) {
            /**
             * Sets the organisation shortcode to a given value
             */
            shortcode.value = orgShortcode;
        }

        function setFormName(type: string | null) {
            /**
             * Sets the payment type/init.
             * @param  {[string]} type - taken from the url parameter
             * @return {[void]} void
             */
            if (type === "undefined" || type === null) {
                formName.value = "invoice";
            } else {
                if (type !== "") {
                    formName.value = type;
                } else {
                    formName.value = "invoice";
                }
            }
        }

        function setOrganisation(org: Organisation | null) {
            /**
             * Sets the organisation object to a given value
             */
            organisation.value = org;
        }

        function setFormStructure(form: Form | null) {
            /**
             * Sets the supplementary form structure
             */
            formStructure.value = form;
        }

        return {
            shortcode,
            formName,
            organisation,
            formStructure,
            setShortcode,
            setFormName,
            setOrganisation,
            setFormStructure,
        };
    },
    {
        persist: {
            pick: ["shortcode", "formName", "organisation", "formStructure"],
            storage: sessionStorage,
        },
    },
);
